module.exports = __webpack_public_path__ + "img/speak6.3b97030d.png";